import { Link, useLocation } from "react-router-dom";
import { PackageX } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

/**
 * 402 — màn hình không nằm trong gói của phòng khám (ADR-0053).
 *
 * <p>Người dùng tới đây khi gõ thẳng một đường dẫn hoặc mở một liên kết cũ tới màn hình mà gói
 * hiện tại không gồm. Trang nói đúng một điều và chỉ một đường ra: gói nào gồm màn hình nào do
 * phòng khám chọn ở Cài đặt › Gói dịch vụ — màn hình đó luôn mở, ở mọi gói.
 *
 * <p>Không liệt kê tính năng của gói nào: gói là thứ quản trị viên cấu hình, và một danh sách viết
 * cứng ở đây sẽ sai ngay lần họ đổi tick.
 */
export function UpgradeRequiredPage() {
  const from = (useLocation().state as { from?: string } | null)?.from;

  return (
    <div className="flex justify-center px-6 py-16">
      <Card className="w-full max-w-xl">
        <CardContent className="space-y-4 p-8">
          <PackageX className="size-8 text-muted-foreground" aria-hidden="true" />
          <h1 className="text-2xl font-semibold tracking-tight text-foreground">
            Tính năng này không có trong gói của phòng khám
          </h1>
          <p className="text-muted-foreground">
            Gói dịch vụ hiện tại không gồm tính năng bạn vừa mở
            {from && (
              <>
                {" "}
                (<span className="font-mono text-sm">{from}</span>)
              </>
            )}
            . Dữ liệu của phòng khám ở tính năng đó, nếu có, vẫn được giữ nguyên.
          </p>
          <div className="flex flex-col gap-2 pt-2 sm:flex-row">
            <Button asChild>
              <Link to="/settings/subscription">Xem gói dịch vụ</Link>
            </Button>
            <Button asChild variant="secondary">
              <Link to="/dashboard">Về Tổng quan</Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
